<div
        class="sp-width__full sp-height__full sp-page__with-navbar"
        [ngClass]="getNavbarClass()">
    <app-navbar
            class="sp-hidden__before-lg"
            [current_nav_item]="current_nav_item"
            [navbar_status]="navbar_status"
            (status_change)="onNavbarStatusChange($event)"></app-navbar>

    <div class="sp-position__relative">
        <app-toolbar
                [current_nav_item]="current_nav_item"
                [width_class]="getToolbarWidthClass()"></app-toolbar>

        <div
                class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2"
                [ngClass]="areFiltersSet() ? 'sp-unpaid__grid-with-filters' : 'sp-unpaid__grid'">
            <app-unpaid-header
                    (refresh)="onRefresh()"
                    (filter)="onFilter()"></app-unpaid-header>

            <app-unpaid-summary></app-unpaid-summary>

            <app-unpaid-filters
                    *ngIf="areFiltersSet()"
                    [filters]="filters"
                    (filter_clear)="onFilterClear($event)"></app-unpaid-filters>

            <app-unpaid-data (refresh)="onRefresh()"></app-unpaid-data>
        </div>
    </div>
</div>
